import axios from '../../v2/app/services/axiosService';
import _ from 'lodash';
import * as types from '../../vuex/mutation-types';
import store from '../../vuex/store';

let initialized = false;
let maxBatchSize = 0;

function checkError(err) {
  if (err && err.response) {
    if (err.response.status === 401) {
      //toastr.error('Your Salesforce.com session has expired. You have to login to Salesforce.', 'Salesforce Session Expired');
      app.$router.push({name: 'salesforce.login_required', query: {redirect_to: window.location.pathname}});
      return;
    }
    if (err.response.status === 403 && err.response.data && err.response.data.error && err.response.data.error === 'The REST API is not enabled for this Organization.') {
      app.$router.push({name: 'salesforce.rest_api_not_enabled'});
      return;
    }
  }
  throw err;
}

export default {
  getLoginInstances() {
    return [
      {id: 'https://login.salesforce.com', name: 'login.salesforce.com'},
      {id: 'https://test.salesforce.com', name: 'test.salesforce.com'},
    ]
  },
  async init() {
    if (!initialized) {
      initialized = true;
      await this.getMaxBatchSize()
        .then(() => {
          console.log('SF is initialized. maxBatchSize is ', maxBatchSize);
        });
    }
  },
  async clearCache() {
    await this.init();
    const response = await axios.delete(`/api/salesforce/cache`);
    return response.data;
  },
  async getAccounts() {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/accounts`);
      response.data.forEach(r => {
        r.busy = false;
      });
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getAccount(id) {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/accounts/${id}`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getConfiguration() { // MLD-1631
    const response = await axios.get(`/api/salesforce/configuration`);
    return response.data;
  },
  async createConfiguration(form) {
    const response = await axios.post(`/api/salesforce/configuration`, form);
    return response.data;
  },
  async updateConfiguration(configurationID, form) {
    const response = await axios.put(`/api/salesforce/configuration/${configurationID}`, form);
    return response.data;
  },
  async getContacts() {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/contacts`);
      response.data.forEach(r => {
        r.busy = false;
      });
      store.commit(types.SET_CONTACTS, response.data);
      return _.clone(response.data);
    } catch (err) {
      return checkError(err);
    }
  },
  async getContact(id) {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/contacts/${id}`);
      console.log('Got Contact', id, response.data);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async updateContact(contact) {
    try {
      const response = await axios.patch(`/api/salesforce/contacts/${contact.Id}`, _.omit(contact, ['Id']));
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getLimits() {
    const response = await axios.get(`/api/salesforce/organization/limits`);
    return response.data;
  },
  async getObjects() {
    const response = await axios.get(`/api/salesforce/organization/objects`);
    return response.data;
  },
  async getMaxBatchSize() {
    if (maxBatchSize) {
      return maxBatchSize;
    }
    const data = await this.getObjects();
    maxBatchSize = parseInt(data.maxBatchSize);
    return data.maxBatchSize;
  },
  async getTasks() {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/tasks`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getUsers() {
    await this.init();
    try {
      const response = await axios.get(`/api/salesforce/users`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getUser(userId) {
    await this.init();
    if (!userId) {
      return null;
    }
    try {
      const response = await axios.get(`/api/salesforce/users/${userId}`);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async createDeviceSession(form) {
    try {
      const response = await axios.post(`/api/salesforce/tasks`, form);
      return response.data;
    } catch (err) {
      return checkError(err);
    }
  },
  async getProfiles() { // MLD-5149
    const response = await axios.get(`/api/salesforce/profiles`);
    return response.data;
  },
  async parameterizedSearch(form) { // MLD-5823
    const response = await form.post(`/api/salesforce/search`);
    return response.data;
  },
  async getObject(object, objectID) { // MLD-6667
    const response = await axios.get(`/api/salesforce/objects/${object}/${objectID}`);
    return response.data;
  }
}
